
import { UserInfo } from "@/models/dossier/user-info";
import Vue from "vue";

export default Vue.extend({
	data() {
		return {
			input: ""
		};
	},
	props: {
		fancy: Boolean,
		value: Object as () => UserInfo,
		label: {
			type: String,
		},
		users: Array as () => UserInfo[]
	},
	computed: {
		filteredUsers():UserInfo[] {
			if (this.input == "") {
				return [];
			}

			return this.users.filter(u => u.getUserString().toLowerCase().match(this.input.toLowerCase()));
		}
	},
	watch: {
		value: {
			immediate: true,
			handler() {
				if (!this.value) {
					this.input = "";
					return;
				}
				this.input = this.value.getUserString();
			}
		},
	},
	methods: {
		selectUser(user:UserInfo) {
			this.$emit("input", user);
			this.input = "";
		}
	},
});
